import { BODY_FONT } from '../text.utils'
import type { TicketElement } from '../TicketElement'

export class SubTitle implements TicketElement {
  text: string
  paddingTop: number
  paddingBottom: number
  fontSize: number

  constructor(text: string, { fontSize }: { fontSize?: number } = {}) {
    this.text = text
    this.paddingTop = 4
    this.paddingBottom = 4
    this.fontSize = fontSize || 20
  }

  height(): number {
    return this.paddingTop + this.fontSize + this.paddingBottom
  }

  render(top: number, ctx: CanvasRenderingContext2D, width: number): void {
    top += this.paddingTop

    ctx.font = `bold ${this.fontSize}px ${BODY_FONT}`
    if (ctx.measureText(this.text).width > width) {
      this.fontSize = Math.floor((this.fontSize * width) / ctx.measureText(this.text).width)
      ctx.font = `bold ${this.fontSize}px ${BODY_FONT}`
    }

    ctx.fillStyle = 'black'
    ctx.textBaseline = 'middle'
    ctx.textAlign = 'center'
    ctx.fillText(this.text, width / 2, top + this.fontSize / 2)
  }
}
